import { Categorie } from "@/types/categorie";
import { formatCategories } from "@/utils/categories";
import { createContext, useEffect, useState } from "react";

export const CategoryContext = createContext<Categorie[]>([]);

const useCategories = () => {
    const [categories, setCategories] = useState<Categorie[]>([]);

    useEffect(() => {
        let isMounted = true;
        const fetchCategories = async () => {
            const result = await fetch("/api/categories").then((res) => res.json());
            if (isMounted) {
                const formatedCategories = formatCategories(result.items);
                setCategories(formatedCategories);
            }

        };

        fetchCategories();

        return () => {
            isMounted = false;    
        };
    }, []);

    return categories;
};

export default useCategories;
